module.exports = __webpack_public_path__ + "img/heart_4.9d6f5f97.png";